'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _AppBase = require('./AppBase');Object.defineProperty(exports, 'AppBase', { enumerable: true, get: function get() {return _AppBase.AppBase;} });
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb250YWluZXJzL2luZGV4LmpzIl0sIm5hbWVzIjpbIkFwcEJhc2UiXSwibWFwcGluZ3MiOiJrTkFBU0EsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IEFwcEJhc2UgfSBmcm9tICcuL0FwcEJhc2UnO1xuIl19


//////////////////
// WEBPACK FOOTER
// ../@react-components/dist/containers/index.js
// module id = 577
// module chunks = 0